<template>
  <div class="container py-5 intro-page">

    <!-- Title -->
    <h2 class="page-title mb-4">Introduction to Computer</h2>

    <!-- Description -->
    <p class="lead">
      This page covers the basic concepts of computers, including definitions,
      components, benefits, and real-world applications. Suitable for beginners.
    </p>

    <!-- Section 1 -->
    <div class="card-section mt-4">
      <h4 class="section-title">💡 What is a Computer?</h4>
      <p>
        A computer is an electronic machine that processes data into meaningful
        information. It can store, retrieve, and calculate data at high speed
        with great accuracy.
      </p>
    </div>

    <!-- Section 2 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🖥 Basic Components</h4>
      <ul>
        <li><strong>Input Devices:</strong> Keyboard, Mouse, Scanner</li>
        <li><strong>Output Devices:</strong> Monitor, Printer, Speakers</li>
        <li><strong>CPU:</strong> The brain of the computer</li>
        <li><strong>Storage:</strong> Hard Disk, SSD, Pen Drive</li>
      </ul>
    </div>

    <!-- Section 3 -->
    <div class="card-section mt-4">
      <h4 class="section-title">🎯 Uses of Computers</h4>
      <ul>
        <li>Education</li>
        <li>Business</li>
        <li>Communication</li>
        <li>Entertainment</li>
        <li>Engineering & Design</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "IntroToComputer",
};
</script>

<style scoped>
.page-title {
  font-weight: 800;
  color: #2563eb;
}

.lead {
  color: #374151;
  font-size: 1.1rem;
}

.card-section {
  background: #ffffff;
  padding: 20px 24px;
  border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border-left: 4px solid #2563eb;
}

.section-title {
  color: #1e40af;
  font-weight: 600;
}
</style>
